// 意大利----address
module.exports = {
  validate: {
    noEmail: "L'e-mail non può essere vuota, per favore reinserisci",
    noPhone:
      "Il numero di telefono non può essere vuoto, inseriscilo nuovamente",
    errorReg:
      "La lunghezza di input è di 1-50 cifre, è possibile inserire lettere maiuscole e minuscole, numeri, simboli - . _ @",
    noPassword: "La password non può essere vuota, inseriscila nuovamente",
    pwdReg:
      "La lunghezza dell'inserimento della password è di sole 8-32 cifre e deve contenere numeri e lettere",
    pwdCheck: "Le due password inserite sono incoerenti, reinserire",
    pwdLengthReg:
      "La lunghezza della password va da 8 a 32, confermare l'inserimento",
    noCode: "inserisci il codice di verifica",
    codeReg: "Inserisci un codice di verifica a 6 cifre",
    nullText: "L'input non può essere vuoto, per favore reinserisci",
    phoneCheck:
      "Il numero di telefono inserito due volte è incoerente, si prega di inserirlo nuovamente",
    emailNumReg:
      "La lunghezza dell'email inserita è di 6-50 caratteri, per favore reinserisci",
    emailReg: "Indirizzo e-mail errato, inseriscilo nuovamente",
    emailCheck:
      "L'account e-mail immesso due volte è incoerente, si prega di reinserirlo",
    noUsername:
      "La password non può contenere il numero di conto, si prega di inserire nuovamente",
    accountReg:
      "L'inserimento del nome dell'account non è corretto, inseriscilo nuovamente",
  },
  area: {
    areaTitle: "Gestione del territorio",
    add: "Aggiungi area",
    area: "la zona",
    addNextArea: "Crea una nuova area subordinata",
    areaNameTip: "Inserisci il nome di una regione",
    areaNameHold:
      "La lunghezza di input è di 1-20 cifre, non è possibile inserire simboli speciali",
    areaNumHold:
      "La lunghezza di input è di 1-4 cifre, è possibile inserire solo numeri e l'intervallo di numeri è 0-9999",
    areaNumTip: "Inserisci il numero dell'area",
    areaName: "Nome zona",
    checkAreaName:
      "Il nome dell'area non può essere vuoto, inseriscilo nuovamente",
    areaNameTip1: "Il nome dell'area non può essere vuoto",
    areaNameTip2: "Inserimento nome area errato, reinserire",
    areaNum: "Numero zona",
    checkAreaNum: "L'ID area non può essere vuoto, inseriscilo nuovamente",
    lastLevel: "Appartiene alla zona superiore",
    checkLastLevel:
      "L'area di livello superiore a cui appartiene non può essere vuota, seleziona di nuovo",
    lastLevelTip: "Seleziona l'area principale a cui appartieni",
    delInfo:
      "L'esecuzione di questa attività di eliminazione eliminerà i dati in quest'area e non potrà essere recuperata",
    oneStep: "livello uno",
    twoStep: "secondario",
    threeStep: "Livello 3",
    fourStep: "Livello 4",
    fiveStep: "Livello 5",
    delAreaTip: "C'è un'area subordinata, che non può essere cancellata",
    personArea: "La persona non è vincolata al territorio",
    areaType: "Aggiungi metodo",
    addArea1: "Aggiungi separatamente",
    addArea2: "aggiunta continua",
    addArea3: "Addizione di matrice",
    areaNameTop: "Prefisso nome zona",
    areaNameLast: "Suffisso nome zona",
    areaJoinHold: "Inserisci il prefisso del nome di dominio",
    areaJoinHold1: "Inserisci il suffisso del nome dell'area",
    startNum: "Numero iniziale",
    checkStartNum: "L'inserimento del numero iniziale è errato, reinserire",
    checkStartNum1:
      "L'inserimento del numero di partenza non può essere vuoto, si prega di inserire nuovamente",
    checkEndNum:
      "L'immissione del numero finale è errata, si prega di inserire nuovamente",
    checkEndNum1:
      "Il numero finale non può essere vuoto, inseriscilo nuovamente",
    endNum: "Numero finale",
    topStart: "Numero iniziale intestazione",
    checkTopStart:
      "L'inserimento del primo numero di partenza non è corretto, si prega di inserire nuovamente",
    checkTopStart1:
      "L'inserimento del primo numero di partenza non può essere vuoto, si prega di inserire nuovamente",
    topEnd: "Numero finale intestazione",
    checkTopEnd:
      "Inserire il numero finale dell'intestazione non è corretto, inserire nuovamente",
    checkTopEnd1:
      "L'inserimento del primo numero finale non può essere vuoto, si prega di inserire nuovamente",
    lastStart: "Numero iniziale di coda",
    checkLastStart:
      "L'inserimento del numero di partenza della coda è errato, si prega di reinserirlo",
    checkLastStart1:
      "Inserisci il numero di partenza della coda non può essere vuoto, per favore reinserisci",
    lastEnd: "Numero di fine percorso",
    checkLastEnd:
      "Inserisci il numero finale della coda è sbagliato, per favore reinserisci",
    checkLastEnd1:
      "L'inserimento del numero di coda non può essere vuoto, si prega di inserire nuovamente",
    topTip:
      "La lunghezza di input è di 1-2 cifre, è possibile inserire solo numeri e l'intervallo di numeri è 1-99",
    lastTip:
      "La lunghezza di input è di 1-2 cifre, è possibile inserire solo numeri e l'intervallo di numeri è 1-99",
    areaNameTest: "Esempio nome area",
  },
  addressBook: {
    config: "Configurazione progetto",
    errorTip: "Errore nel formato della rubrica",
    upgrade: "Gestione dell'aggiornamento della rubrica",
    deviceIdTip: "Inserisci l'ID del dispositivo",
    deviceId: "ID del dispositivo",
    syncAll: "Sincronizza tutto",
    sync: "Sincronizzare",
    sysVersion: "Versione attuale della rubrica di sistema",
    deviceVersion: "Versione attuale della rubrica del dispositivo",
    syncTip: "Emesso con successo il comando sincrono",
  },
  newarea: {
    add: "Aggiungi area",
    edit: "Modifica zona",
    smallTip:
      "Attualmente il livello di area più piccolo, non è possibile aggiungere ulteriori sottoaree",
    batch: "Area aggiunta batch",
    batch1: "aggiunta continua",
    batch2: "Addizione di matrice",
  },
  deviceSip: {
    saveTip:
      "Esporta la rubrica in tempo, altrimenti tutti i dati verranno cancellati dopo l'uscita dalla pagina.",
    devMsg: "Informazioni sul dispositivo",
    list: "Elenco dispositivi",
    add: "Aggiungi dispositivo",
    edit: "Modifica dispositivo",
    batch: "Aggiungi dispositivi in batch",
    areaChosen: "Selezione livello area",
    areaNum: "Numero di nuovi dispositivi aggiunti in ciascuna area",
    bacthTip:
      "Quando il livello dell'area è selezionato come un edificio e il numero di nuovi dispositivi in ogni area è 4, significa che vengono aggiunti 4 dispositivi in ogni area creata",
    note: "illustrare",
    baseConfig: "Configurazione delle informazioni di base",
    deviceName: "Nome del dispositivo",
    nameTip:
      "Risolto per aggiungere un numero al nome del gruppo a cui appartiene, ad esempio Edificio 1-1",
    function: "Funzione di supporto del dispositivo",
    net: "Configurazione di rete",
    netType: "Tipo di rete",
    netTip1:
      "Static è una rete statica, è necessario impostare manualmente l'IP e altre informazioni.",
    netTip2:
      "DHCP è una rete dinamica e informazioni come l'IP vengono assegnate automaticamente dal router.",
    mask: "Inserisci la maschera di sottorete",
    gateway: "Si prega di inserire il gateway",
    ip: "Inserisci l'indirizzo IP",
    ipTip:
      "L'indirizzo IP di input deve evitare IP speciali, come 127.0.0.1, ecc.",
    dns1: "Inserisci DNS1",
    dns2: "Inserisci DNS2",
    sip1: "configurazione informazioni sip1",
    config: "Configurazione delle informazioni",
    mode: "modello",
    mode1: "Modalità diretta",
    mode2: "Modalità server",
    user: "inserisci il nome utente",
    userTitle: "nome utente",
    userTip:
      "L'impostazione predefinita è aggiungere un numero al nome del gruppo, ad esempio 1-1-1",
    last: "Inserisci il suffisso dell'account",
    sipTip: "Inserire il nome utente registrato e la password del server SIP",
    password: "Per favore inserisci LA TUA password",
    passwordTitle: "parola d'ordine",
    serverIp: "Inserisci l'IP del server",
    protocolType: "Seleziona il tipo di protocollo",
    protocolTypeTitle: "tipo di accordo",
    sip2: "configurazione informazioni SIP2",
    more: "Di più",
    close: "chiusura",
    formatError: "Errore di formato, reinserire",
    forbidTip: "Vietato inserire 127.0.0.1, si prega di reinserire",
    call: "Chiama e chiama",
    monitor: "tenere sotto controllo",
    lift: "Controllo ascensore",
    rtsp: "flusso video rtsp",
    deviceTip:
      "La funzione di supporto del dispositivo non può essere vuota, scegli di nuovo",
    maskTip1: "La subnet mask non può essere vuota, per favore reinserisci",
    maskTip2: "Il formato della maschera di sottorete è errato, reinserire",
    gatewayTip1: "Il gateway non può essere vuoto, si prega di rientrare",
    gatewayTip2: "Errore formato gateway, reinserire",
    ipTip1: "L'indirizzo IP non può essere vuoto, inseriscilo nuovamente",
    ipTip2:
      "Errore nel formato dell'indirizzo IP, il limite massimo è 255.254.254.253, il primo paragrafo non è 0, inserire nuovamente",
    dns1Tip1: "DNS1 non può essere vuoto, per favore reinserisci",
    dns1Tip2: "Errore formato DNS1, reinserire",
    dns2Tip1: "Errore formato DNS2, reinserire",
    passwordTip1: "La password non può essere vuota, inseriscila nuovamente",
    serviceTip1: "serviceIp non può essere vuoto, per favore reinserisci",
    serviceTip2: "errore formato serviceIp, reinserire",
    sip2Tip:
      "Attualmente hai configurato le informazioni sip2, completale secondo le regole",
    devnameTip1:
      "Il nome del dispositivo non può essere vuoto, inseriscilo nuovamente",
    devnameTip2: "Errore nel formato del nome del dispositivo, reinserire",
    nameTip1: "Il nome utente non può essere vuoto, scegli di nuovo",
    nameTip2: "Il nome utente non può essere vuoto, scegli di nuovo",
    maxTip1:
      "Il numero di dispositivi nell'area corrente ha raggiunto il limite massimo di 8 e non è possibile aggiungerne altri",
    area: "la zona",
    editArea: "Modifica zona",
    addArea: "Aggiungi area",
    batchArea: "Area aggiunta batch",
    deleteArea: "Elimina regione",
    areaName: "Nome zona",
    areaNo: "Numero zona",
    importAddr: "Importa rubrica",
    next: "Passo successivo",
    areaTip1: "Seleziona prima l'area da modificare",
    areaTip2: "Seleziona prima l'area da eliminare",
    areaTip3:
      "La tua area attuale è vuota, al momento non puoi aggiungere dispositivi in batch, aggiungi prima le informazioni sull'area",
    noArea: "Nessuna configurazione di zona ancora",
    error: "Eccezione dati",
    addDevice: "Aggiungi dispositivo",
    editDevice: "Modifica dispositivo",
    delDevice: "Elimina dispositivo",
    batchDevice: "Aggiungi dispositivi in batch",
    prev: "Precedente",
    updateAddr: "Aggiorna rubrica dispositivo",
    saveAddr: "Salva rubrica",
    exportAddr: "Esporta rubrica",
    deleteTip: "Se eliminare il dispositivo",
    deleteTip2:
      "Attualmente selezionata come regione, torna alla configurazione della regione per eliminarla",
    deleteTip3: "Seleziona prima il dispositivo da eliminare",
    deviceTip1: "Seleziona prima il dispositivo da modificare",
    deviceTip2: "Seleziona prima la regione, quindi aggiungi il dispositivo",
    exportSuccess: "Esportazione riuscita",
    xmlTip: "Carica il file xml della rubrica",
    xmlTip1: "Seleziona il file xml da caricare",
    xmlTip2:
      "La rubrica importata non è coerente con l'attuale livello di comunità e l'importazione non è riuscita",
    areaConfig: "Configurazione dell'area",
    deviceConfig: "Configurazione dispositivo",
    exportConfig: "Anteprima esportazione",
    projectConfig: "Configurazione progetto",
    prevArea: "Appartiene alla zona superiore",
    areaNoTip:
      "Il numero di partenza è maggiore del numero di fine, si prega di compilare di nuovo",
    smallAreaTip:
      "Attualmente il livello di area più piccolo, non è possibile aggiungere ulteriori sottoaree",
    areaNoTip1:
      "Il numero iniziale della prima parte è maggiore del numero finale della prima parte, si prega di compilare nuovamente",
    areaNoTip2:
      "Il numero iniziale della coda è maggiore del numero finale della coda, si prega di compilare di nuovo",
  },
  push: {
    list: "Premi Registra",
    productType: "Numero del prodotto",
    softwareName: "nome del software",
    versionNo: "numero della versione",
    time: "Tempo di spinta",
    invalidTime: "Data di scadenza",
    upgrade: "aggiornamento",
    upgradeRecord: "Visualizza record di aggiornamento",
    deviceType: "Tipo di apparecchiatura",
    deviceName: "Nome del dispositivo",
    currentSoftName: "Nome del software del dispositivo corrente",
    currentSoftNo: "Numero di versione attuale del dispositivo",
    upgradeNo: "Aggiorna numero versione software",
    filterTip1: "Inserisci il nome del dispositivo",
    filterTip2: "Selezionare il nome del software",
    filterTip3: "Seleziona un numero di versione",
    checkTip: "Attiva segno di spunta",
    ota: "Aggiornamento OTA",
    taskName: "nome missione",
    taskNameTip: "Inserisci un nome per l'attività",
    binName: "Nome firmware",
    upgradeType: "Metodo di aggiornamento dell'attività",
    done: "Se eseguire immediatamente",
    upgradeTime: "tempo di aggiornamento",
  },
  check: {
    submit: "Congratulazioni, l'invio è andato a buon fine!",
    noSubmit: "Oops, invio non riuscito!",
    file: "Seleziona un documento",
    noFile: "Nessun file selezionato",
    projectName: "Nome del progetto",
    projectNameTip: "Inserisci un nome per il progetto",
    describe: "descrivere",
    contentTip: "Inserisci contenuto",
    areaType: "Gerarchia regionale",
    example: "Ad esempio: numero unità immobiliare-stanza",
    areaTip: "Il formato del numero dell'area è errato, inserire nuovamente",
    areaNameTip: "Inserisci un nome di livello",
    nameTip: "Il nome non può essere vuoto, inseriscilo nuovamente",
    nameError:
      "Il nome è stato inserito in modo errato, inseriscilo nuovamente",
    nameLength: "La lunghezza del nome inserito è 4~50, per favore reinserisci",
    areaNullTip: "Il livello dell'area non può essere vuoto",
    formateError:
      "La lunghezza è di 1-6 cifre, non è possibile inserire simboli speciali",
    noAreaTip:
      "Il livello dell'area non può essere vuoto, selezionare di nuovo",
    maxFileTip: "La dimensione del file supera il limite",
    xmlTip: "Carica un file in formato XML",
  },
  book: {
    areaBy: "Regione",
    list: "Elenco duplicati informazioni dispositivo",
    repeatTip:
      "Le seguenti informazioni sull'attrezzatura sono duplicate. Modificare le informazioni sull'attrezzatura duplicate. Dopo aver fatto clic su 'Conferma', giudicherà la duplicazione delle informazioni di input dell'attrezzatura.",
    coverTip:
      "Questa operazione sovrascriverà i dati di aggiunta batch del livello attualmente selezionato",
    batchTip: "L'intervallo IP generato dall'aggiunta di dispositivi in batch",
  },
  updateNewSip: {
    otaDeleteTip:
      "Eliminazione non riuscita, è possibile eliminare solo le attività non avviate",
    deleteArea1: "Se eliminare la regione",
    deleteArea2:
      "Allo stesso tempo, tutte le aree e i dispositivi al di sotto di quest'area verranno eliminati insieme",
    codeRepeatTip:
      "L'ID regione dello stesso livello non può essere ripetuto, inserire nuovamente l'ID regione corrente",
    nameRepeatTip:
      "I nomi delle aree allo stesso livello non possono essere duplicati, si prega di reinserire il nome della regione corrente",
    deviceIp: "IP dispositivo",
    callin: "Chiamare",
    callout: "espirare",
    systemMsg: "informazioni di sistema",
    batchIpTip:
      "L'intervallo IP generato questa volta aggiungendo dispositivi in batch",
    ip: "Indirizzo IP",
    mask: "Maschera di sottorete",
    gateway: "Porta",
    noData: "NO",
    noAddressTip:
      "Al momento non ci sono dati della rubrica che possono essere sincronizzati",
    operator: "Operatore",
    goTip: "Fai clic per passare al passaggio corrispondente",
    deviceNameTip:
      "La lunghezza di input è di 1-16 cifre, non è possibile inserire simboli speciali",
    filter1: "Inserisci il nome di un'area da filtrare",
    filter2:
      "Inserisci il nome dell'area o il nome del dispositivo da filtrare",
    secret: "Password di crittografia",
    secretTip:
      "Inserisci una password entro 32 caratteri, il formato non è limitato",
    noSecretTip:
      "La password di crittografia non impostata può essere ignorata",
    setSecret: "Imposta la password di crittografia della rubrica",
    ignore: "trascurare",
    emptyBookTip:
      "La rubrica è vuota e non può essere temporaneamente esportata",
    errorSecret: "Errore password crittografia rubrica, reinserire",
    other: "altro",
    doorAuth: "Controllo di accesso",
    funTitle:
      "Controlla le funzioni supportate dal dispositivo che hai aggiunto",
    callInTip: "Chiamata di assistenza del dispositivo",
    callOutTip: "Viene chiamato il supporto del dispositivo",
    monitorTip: "Il dispositivo supporta il monitoraggio",
    doorTip: "Il dispositivo supporta la funzione di sblocco",
    liftTip: "Elevatore di controllo del supporto del dispositivo",
    maskTip: "Inserisci la subnet mask, riferimento formato: 255.255.255.255",
    gatewayTip: "Inserire il gateway, riferimento formato: 1.1.1.1",
    ip1: "Si prega di inserire l'indirizzo IP, riferimento formato: 1.1.1.1",
    ipTip:
      "L'indirizzo IP di input deve evitare IP speciali, come 127.0.0.1, ecc.",
    dns1: "Inserisci DNS1, riferimento formato: 1.1.1.1",
    dns2: "Inserisci DNS2, riferimento formato: 1.1.1.1",
    serverIp: "Inserisci IPserver, riferimento formato: 1.1.1.1 o nome dominio",
    successxml: "File analizzato con successo",
    groupCall: "chiamata di gruppo",
    groupCallTip:
      "Dopo l'accensione, puoi chiamare tutti i dispositivi del gruppo facendo clic sull'icona della chiamata di gruppo",
    record: "registrazione versione",
    export: "esportare",
    sync: "Sincronizzare",
    communityTip:
      "Attualmente sono presenti dati del dispositivo dell'area, il cambio di livello dell'area è proibito",
    areaNameTitle: "Descrizione della gerarchia",
    noDataTip: "Attualmente non ci sono dati",
    areaCodeDescriptionTip:
      "La descrizione dell'area non può essere vuota, compila completamente",
    moduleName: "Strumento di configurazione della rubrica indirizzi",
    userSipAccount:
      "Fissato come numero di area del gruppo genitore + numero di attrezzatura",
    devMax: "Device node exceeded limit of 10000 entries, failed to add",
    areaMax: "Area node exceeded the limit of 10000 entries, failed to add",
    ipAndMaskTip1:
      "L'indirizzo IP è associato alla maschera di sottorete e deve superare la validazione della logica aziendale avendo risultati con tutti 1 o tutti 0 dopo l'operazione AND bit a bit.",
    ipAndMaskTip2:
      "Se si verifica un errore nella regola di convalida aziendale, si prega di modificare l'indirizzo IP corrispondente.",
    ipAndMaskTip3:
      "Le regole di convalida aziendale della maschera di sottorete e dell'indirizzo IP sono errate. Si prega di modificare l'indirizzo IP.",
    ipAndMaskTip4:
      "Durante l'aggiunta in blocco dei dispositivi, gli IP che non soddisfano la convalida della logica aziendale verranno automaticamente saltati.",
    correctMaskTip:
      "Si prega di compilare prima la maschera di sottorete corretta.",
    correctIpTip: "Si prega di inserire l'indirizzo IP corretto.",
  },
  newDeviceType: {
    indoorMachine: "Unità interna",
    doorPhone: "Interfono",
    smallDoor: "Interfono piccolo",
    manage: "Dispositivo di gestione",
    wall: "Dispositivo per muro",
    monitor: "Telecamera IP",
    unitGuard: "Dispositivo di gestione del blocco",
    networkCard: "Lettore di carte di rete",
    unitCard: "Lettore di carte del blocco",
    lift: "Modulo di interazione con l'ascensore",
    deviceTypeTip: "Per favore, seleziona il tipo di dispositivo"
    }
};
